module.exports = __webpack_public_path__ + "static/media/foto7.dcd48d11.jpeg";